import React, { Component } from "react";
// import store from "../../../AppRedux/store";
import {
    ExecuteLayoutEventMethods,
    GetControlPropertyFromStoreOrRefData,
    getProcessedDynamic,
} from "../../../General/commonFunctions";
import LayoutManipulator from "../../../General/layoutManipulator";
import { ownStore } from "../../../AppOwnState/ownState";
import PureJSDesignerFactory from "../../Pages/Factory/pureJSDesignerFactory";
import PureJSComponentFactory from "../../Pages/Factory/pureJSComponentFactory";

class FactsRenderer extends Component {
    constructor(props) {
        super(props);
        let newLY = this.getCurrentLayout();

        let _propsRedux = null;
        if (props.appendprops) _propsRedux = getProcessedDynamic(props.appendprops);
        let scaff = null;
        if (_propsRedux?.renderer === "real")
            scaff = new PureJSComponentFactory().scaffoldComponent(
                newLY,
                this.props.refData
            );
        else {
            let neutralLY = new LayoutManipulator().neutralize(
                newLY,
                this.props.layout.replace("[", "").replace("]", "")
            );

            scaff = new PureJSDesignerFactory().scaffoldComponent(
                neutralLY,
                this.props.refData
            );
        }
        this.state = {
            currentLY: newLY,
            scaff: scaff,
            propsRedux: _propsRedux,
            draggedItemPosition: null,
        };
        this.canvasRef = React.createRef();
    }
    getCurrentLayout() {
        let layt = GetControlPropertyFromStoreOrRefData(this.props.layout);
        return layt;
    }

    async runAction(e, eventToRun) {
        if (e.target.closest(".c-render")) {
            e.stopPropagation();
            e.preventDefault();
            document.querySelectorAll("[data-ctr-class=dz-ctr]").forEach((t) => {
                t.classList.remove("dz-active");
            });
            let validElement = e.target;
            if (e.target.getAttribute("data-ctr-class") !== "dz-ctr") {
                validElement = validElement.closest("[data-ctr-class=dz-ctr]");
            }
            if (validElement.getAttribute("data-ctr-class") === "dz-ctr") {
                validElement.classList.add("dz-active");
                let dataCtrPath = validElement.getAttribute("data-ctr-path");
                let dataCtrChild = validElement.getAttribute("data-ctr-child");
                let desProps = {
                    path: dataCtrPath,
                    name: validElement.getAttribute("data-ctr-title"),
                    child: dataCtrPath + (dataCtrChild ? "." + dataCtrChild : ""),
                };

                await ExecuteLayoutEventMethods(eventToRun, desProps);
            }
        }
    }

    handleDragStart(e) {
        const validElement = e.target.closest("[data-ctr-class=dz-ctr]");
        if (validElement) {
            console.log(e.target.getAttribute("data-ctr-path"), "drag start path");
            const isChild = e.target
                .getAttribute("data-ctr-path")
                ?.split(".")
                ?.includes("chld");

            const dragStartPosition = e.target
                .getAttribute("data-ctr-path")
                ?.split(".")?.[2];

            this.setState({ draggedItemPosition: dragStartPosition || null });
        }
    }

    handleDragOver(e) {
        e.preventDefault();
    }

    updateLayoutPosition(droppedPath, x, y) {
        if (!this.props.layout || !this.state.currentLY) {
            console.error("Cannot update: Layout or currentLY is undefined");
            return;
        }

        let newLayout = JSON.parse(JSON.stringify(this.state.currentLY));
        let layoutManipulator = new LayoutManipulator();

        const pathParts = droppedPath.split(".");
        let current = newLayout;
        for (let i = 0; i < pathParts.length - 1; i++) {
            current = current[pathParts[i]];
            if (!current) return;
        }
        const lastIndex = pathParts[pathParts.length - 1];
        if (current && current[lastIndex]) {
            current[lastIndex].position = { x, y };
        }

        layoutManipulator.updateLayout(this.props.layout, newLayout);

        let scaff = null;
        if (this.state.propsRedux?.renderer === "real") {
            scaff = new PureJSComponentFactory().scaffoldComponent(
                newLayout,
                this.props.refData
            );
        } else {
            let neutralLY = layoutManipulator.neutralize(
                newLayout,
                this.props.layout?.replace("[", "").replace("]", "") || ""
            );
            scaff = new PureJSDesignerFactory().scaffoldComponent(
                neutralLY,
                this.props.refData
            );
        }

        this.setState({
            currentLY: newLayout,
            scaff: scaff,
        });
    }

    applyChildDragAttributes() {
        const childElements = document.querySelectorAll("[data-ctr-class=dz-ctr]");
        childElements.forEach((element) => {
            element.setAttribute("draggable", "true");
            element.ondragstart = (e) => this.handleDragStart(e);
        });
    }

    renderBoxEvents = () => {
        let renderDIV = document.querySelector(".c-render");
        if (renderDIV) {
            renderDIV.onclick = async (e) => this.runAction(e, this.props?.whenclick);
            document.onkeyup = async (e) => {
                if (this.props?.eventkeys?.includes(e.key) || !this.props?.eventkeys)
                    ExecuteLayoutEventMethods(this.props?.whendocumentkeyup);
            };
            renderDIV.ondragover = async (e) => e.preventDefault();
            renderDIV.ondrop = async (e) => {
                e.preventDefault();
                const dropPosition = e.target
                    .closest("[data-ctr-class=dz-ctr]")
                    .getAttribute("data-ctr-path")
                    ?.split(".")?.[2];

                const currentDset = [...(ownStore.getState("dsLayout")?.layout || [])];

                const { draggedItemPosition } = this.state;

                const movingItem = currentDset.splice(draggedItemPosition, 1);
                currentDset.splice(dropPosition, 0, movingItem?.[0]);

                ownStore.dispatch({
                    type: "STORE_DATASET",
                    payload: {
                        dataSetName: "dsLayout",
                        data: { layout: currentDset },
                    },
                });
            };
        }
    };

    componentDidMount() {
        this.renderBoxEvents();
        this.applyChildDragAttributes();

        this.mounted = true;

        if (this.props.layout) {
            this.unsubscribe = ownStore.subscribe(() => {
                if (this.mounted) {
                    let newLY = this.getCurrentLayout();

                    let newPropState = getProcessedDynamic(this.props.appendprops);

                    let scaff = null;
                    if (newPropState?.renderer === "real")
                        scaff = new PureJSComponentFactory().scaffoldComponent(
                            newLY,
                            this.props.refData
                        );
                    else {
                        let neutralLY = new LayoutManipulator().neutralize(
                            newLY,
                            this.props.layout.replace("[", "").replace("]", "")
                        );
                        scaff = new PureJSDesignerFactory().scaffoldComponent(
                            neutralLY,
                            this.props.refData
                        );

                        console.log(neutralLY, "refData in facts renderer");
                    }
                    this.setState({
                        currentLY: newLY,
                        scaff: scaff,
                    });

                    // }

                    if (
                        JSON.stringify(this.state.propsRedux) !==
                        JSON.stringify(newPropState)
                    ) {
                        this.setState(
                            {
                                currentLY: newLY,
                                scaff: scaff,
                                propsRedux: newPropState,
                            },
                            () => {
                                this.applyChildDragAttributes();
                            }
                        );
                    }
                }
            });
        }
    }

    componentDidUpdate() {
        this.applyChildDragAttributes();
    }

    componentWillUnmount() {
        document.onkeyup = undefined;
        this.mounted = false;
        if (this.unsubscribe) this.unsubscribe();
    }

    render() {
        return (
          <div
            ref={this.canvasRef}
            className={"factsRenderer" + (this.props.className ?? "")}
            type="page"
            data-ctr-title="page"
            data-ctr-class="dz-ctr"
            data-ctr-child=""
            data-ctr-path="dsLayout.layout"
            {...this.state.propsRedux}
          >
            {this.state.scaff}
          </div>
        );
    }
}

export default FactsRenderer;





// import React, { Component } from "react";
// // import store from "../../../AppRedux/store";
// import {
//     ExecuteLayoutEventMethods,
//     GetControlPropertyFromStoreOrRefData,
//     getProcessedDynamic,
// } from "../../../General/commonFunctions";
// import LayoutManipulator from "../../../General/layoutManipulator";
// import { ownStore } from "../../../AppOwnState/ownState";
// import PureJSDesignerFactory from "../../Pages/Factory/pureJSDesignerFactory";
// import PureJSComponentFactory from "../../Pages/Factory/pureJSComponentFactory";

// class FactsRenderer extends Component {
//     constructor(props) {
//         super(props);
//         let newLY = this.getCurrentLayout();

//         let _propsRedux = null;
//         if (props.appendprops) _propsRedux = getProcessedDynamic(props.appendprops);
//         let scaff = null;
//         if (_propsRedux?.renderer === "real")
//             scaff = new PureJSComponentFactory().scaffoldComponent(
//                 newLY,
//                 this.props.refData
//             );
//         else {
//             let neutralLY = new LayoutManipulator().neutralize(
//                 newLY,
//                 this.props.layout.replace("[", "").replace("]", "")
//             );

//             scaff = new PureJSDesignerFactory().scaffoldComponent(
//                 neutralLY,
//                 this.props.refData
//             );
//         }
//         this.state = {
//             currentLY: newLY,
//             scaff: scaff,
//             propsRedux: _propsRedux,
//             draggedItem: null,
//             dragStartPath: null,
//             dragEndPath: null,
//         };
//         this.canvasRef = React.createRef();
//     }
//     getCurrentLayout() {
//         let layt = GetControlPropertyFromStoreOrRefData(this.props.layout);
//         return layt;
//     }

//     async runAction(e, eventToRun) {
//         if (e.target.closest(".c-render")) {
//             e.stopPropagation();
//             e.preventDefault();
//             document.querySelectorAll("[data-ctr-class=dz-ctr]").forEach((t) => {
//                 t.classList.remove("dz-active");
//             });
//             let validElement = e.target;
//             if (e.target.getAttribute("data-ctr-class") !== "dz-ctr") {
//                 validElement = validElement.closest("[data-ctr-class=dz-ctr]");
//             }
//             if (validElement.getAttribute("data-ctr-class") === "dz-ctr") {
//                 validElement.classList.add("dz-active");
//                 let dataCtrPath = validElement.getAttribute("data-ctr-path");
//                 let dataCtrChild = validElement.getAttribute("data-ctr-child");
//                 let desProps = {
//                     path: dataCtrPath,
//                     name: validElement.getAttribute("data-ctr-title"),
//                     child: dataCtrPath + (dataCtrChild ? "." + dataCtrChild : ""),
//                 };

//                 await ExecuteLayoutEventMethods(eventToRun, desProps);
//             }
//         }
//     }

//     getPathValue(obj, path) {
//         const keys = path
//             .split(".")
//             .map((key) => (/^\d+$/.test(key) ? Number(key) : key));
//         return keys.reduce((acc, key) => acc?.[key], obj);
//     }

//     handleDragStart(e) {
//         const validElement = e.target.closest("[data-ctr-class=dz-ctr]");
//         if (validElement) {
//             const thePath = e.target?.getAttribute("data-ctr-path");
//             const pathStr = thePath?.split("dsLayout.");

//             const currentDset = ownStore.getState("dsLayout");
//             const theMovedItem = this.getPathValue(currentDset, pathStr?.[1]);
//             console.log(theMovedItem, "theMovedItem");

//             this.setState({ draggedItem: theMovedItem || null });
//             this.setState({ dragStartPath: pathStr?.[1] || null });
//         }
//     }

//     handleDragOver(e) {
//         e.preventDefault();
//     }

//     updateLayoutPosition(droppedPath, x, y) {
//         if (!this.props.layout || !this.state.currentLY) {
//             console.error("Cannot update: Layout or currentLY is undefined");
//             return;
//         }

//         let newLayout = JSON.parse(JSON.stringify(this.state.currentLY));
//         let layoutManipulator = new LayoutManipulator();

//         // Update the element at the droppedPath with new position
//         const pathParts = droppedPath.split(".");
//         let current = newLayout;
//         for (let i = 0; i < pathParts.length - 1; i++) {
//             current = current[pathParts[i]];
//             if (!current) return;
//         }
//         const lastIndex = pathParts[pathParts.length - 1];
//         if (current && current[lastIndex]) {
//             current[lastIndex].position = { x, y }; // Add position to the element
//         }

//         // Update layout in store
//         layoutManipulator.updateLayout(this.props.layout, newLayout);

//         // Update scaffold
//         let scaff = null;
//         if (this.state.propsRedux?.renderer === "real") {
//             scaff = new PureJSComponentFactory().scaffoldComponent(
//                 newLayout,
//                 this.props.refData
//             );
//         } else {
//             let neutralLY = layoutManipulator.neutralize(
//                 newLayout,
//                 this.props.layout?.replace("[", "").replace("]", "") || ""
//             );
//             scaff = new PureJSDesignerFactory().scaffoldComponent(
//                 neutralLY,
//                 this.props.refData
//             );
//         }

//         this.setState({
//             currentLY: newLayout,
//             scaff: scaff,
//         });
//     }

//     applyChildDragAttributes() {
//         const childElements = document.querySelectorAll("[data-ctr-class=dz-ctr]");
//         childElements.forEach((element) => {
//             element.setAttribute("draggable", "true");
//             element.ondragstart = (e) => this.handleDragStart(e);
//         });
//     }

//     renderBoxEvents = () => {
//         let renderDIV = document.querySelector(".c-render");
//         if (renderDIV) {
//             renderDIV.onclick = async (e) => this.runAction(e, this.props?.whenclick);
//             document.onkeyup = async (e) => {
//                 if (this.props?.eventkeys?.includes(e.key) || !this.props?.eventkeys)
//                     ExecuteLayoutEventMethods(this.props?.whendocumentkeyup);
//             };
//             renderDIV.ondragover = async (e) => e.preventDefault();
//             renderDIV.ondrop = async (e) => {
//                 e.preventDefault();
//                 // const dropPosition = e.target
//                 //     .closest("[data-ctr-class=dz-ctr]")
//                 //     .getAttribute("data-ctr-path")
//                 //     ?.split(".")?.[2];
//                 const thePath = e.target
//                     .closest("[data-ctr-class=dz-ctr]")
//                     .getAttribute("data-ctr-path");



//                 const dropPath = thePath?.split("dsLayout.")?.[1];
//                 this.setState({ dragStartPath: dropPath || null });
//                 const dropPosition = thePath?.split("dsLayout.")?.[1];

//                 console.log(dropPath, "dropPath");

//                 // dragEndPath

//                 // const currentDset = [...(ownStore.getState("dsLayout")?.layout || [])];
//                 const currentDset = ownStore.getState("dsLayout");
//                 const { draggedItem } = this.state;

//                 const updatedObj = { ...currentDset?.[0] };

//                 // const movingItem = currentDset.splice(draggedItem, 1);
//                 // currentDset.splice(dropPosition, 0, movingItem?.[0]);
//                 const dropZone = this.getPathValue(currentDset, dropPath);
//                 console.log(
//                     currentDset,
//                     this.state.draggedItem,
//                     this.state.dragStartPath,
//                     dropPath,
//                     dropZone,
//                     "currentDset"
//                 );



//                 ownStore.dispatch({
//                     type: "STORE_DATASET",
//                     payload: {
//                         dataSetName: "dsLayout",
//                         data: { layout: currentDset },
//                     },
//                 });
//             };
//         }
//     };

//     componentDidMount() {
//         this.renderBoxEvents();
//         this.applyChildDragAttributes();

//         this.mounted = true;

//         if (this.props.layout) {
//             this.unsubscribe = ownStore.subscribe(() => {
//                 if (this.mounted) {
//                     let newLY = this.getCurrentLayout();

//                     let newPropState = getProcessedDynamic(this.props.appendprops);

//                     let scaff = null;
//                     if (newPropState?.renderer === "real")
//                         scaff = new PureJSComponentFactory().scaffoldComponent(
//                             newLY,
//                             this.props.refData
//                         );
//                     else {
//                         let neutralLY = new LayoutManipulator().neutralize(
//                             newLY,
//                             this.props.layout.replace("[", "").replace("]", "")
//                         );
//                         scaff = new PureJSDesignerFactory().scaffoldComponent(
//                             neutralLY,
//                             this.props.refData
//                         );

//                         console.log(neutralLY, "refData in facts renderer");
//                     }
//                     this.setState({
//                         currentLY: newLY,
//                         scaff: scaff,
//                     });

//                     // }

//                     if (
//                         JSON.stringify(this.state.propsRedux) !==
//                         JSON.stringify(newPropState)
//                     ) {
//                         this.setState(
//                             {
//                                 currentLY: newLY,
//                                 scaff: scaff,
//                                 propsRedux: newPropState,
//                             },
//                             () => {
//                                 this.applyChildDragAttributes();
//                             }
//                         );
//                     }
//                 }
//             });
//         }
//     }

//     componentDidUpdate() {
//         this.applyChildDragAttributes();
//     }

//     componentWillUnmount() {
//         document.onkeyup = undefined;
//         this.mounted = false;
//         if (this.unsubscribe) this.unsubscribe();
//     }

//     render() {
//         return (
//             <div
//                 ref={this.canvasRef}
//                 className={this.props.className}
//                 type="page"
//                 data-ctr-title="page"
//                 data-ctr-class="dz-ctr"
//                 data-ctr-child=""
//                 data-ctr-path="dsLayout.layout"
//                 {...this.state.propsRedux}
//             >
//                 {this.state.scaff}
//             </div>
//         );
//     }
// }

// export default FactsRenderer;
